import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  token: any;
  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private auth: AuthenticationService,
    private global: GlobalService
  ) { }

  ngOnInit() {
    this.sub.add(
      this.activeRoute.paramMap.subscribe(paramMap => {
        if (paramMap.has('token')) {
          this.token = paramMap.get('token');
          console.log(this.token);
          this.handleTokenVerification();
        } else {
          this.router.navigate(['login']);
        }
      })
    );
  }

  handleTokenVerification() {
    this.global.showSpinner();
    const payload = {EmailConfirmationLinkToken: this.token};
    this.sub.add(
      this.auth.verifyCustomersToken(payload).subscribe(
        {
          next: result => {
            this.global.hideSpinnerWithSuccess();
            this.global.handleVerifyEmailResultManipulation(result);
          },
          error: e => {
            this.global.hideSpinnerWithError();
            this.global.handleAuthErrors(e);
            this.router.navigate(['login']);
          }
        }
      )
    );
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
